import { Table } from 'components/shared/Table';
import { PartnerProposalMetricsTableDataResponse } from 'modules/aftermarketPartner/api/types';
import { Column, SortingRule } from 'react-table';

const defaultSorted: SortingRule[] = [{ id: 'totalSent', desc: true }];

export const ReportsTable = ({
  partnerView,
  metricsData,
  loading,
  columns,
}: {
  partnerView: boolean;
  metricsData: any;
  loading: boolean;
  columns: Column<any>[];
}) => {
  return (
    <Table<PartnerProposalMetricsTableDataResponse>
      tableData={metricsData}
      columns={columns}
      loading={loading}
      defaultSorted={defaultSorted}
    />
  );
};
